import React, { createContext, useContext, useState, useEffect } from 'react';
import Translate from '../components/Translate';

const LanguageContext = createContext();
const optionsLang = [
    {
        nameLang: "pt-br",
        nameFlag: "br"
    },
    {
        nameLang: "en",
        nameFlag: "gb uk"
    },
    {
        nameLang: "es",
        nameFlag: "es"
    }];

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(optionsLang[0]);
    const [bankSelected, setBankSelected] = useState("");
    const [orderFromDeposit, setOrderFromDeposit] = useState("");
    const [orderFromRetirada, setOrderFromRetirada] = useState("");


    const translate = (value = null) => {
        if (value != null) {
            let index = optionsLang.findIndex(x => x.nameLang === value);
            setLang(optionsLang[index]);
            Translate(value);
            //console.log("Valor do idioma")
            //console.log(value);
            sessionStorage.setItem("ls-lang", value);
        } else {
            if (sessionStorage.getItem("ls-lang") != null) {
                value = sessionStorage.getItem("ls-lang");
                Translate(value);
            }else{
                Translate(lang.nameLang);
                sessionStorage.setItem("ls-lang", lang.nameLang);
            }
        }
    }

    useEffect(() => {
        let storeLang = sessionStorage.getItem("ls-lang");
        if (storeLang != null){
            let index = optionsLang.findIndex(x => x.nameLang === storeLang);
            setLang(optionsLang[index]);
        }
    },[]);

    return (
        <LanguageContext.Provider
            value={{
                lang,
                setLang,
                optionsLang,
                translate,
                orderFromDeposit, 
                setOrderFromDeposit,
                orderFromRetirada, 
                setOrderFromRetirada,
                bankSelected,
                setBankSelected
            }}>
            {children}
        </LanguageContext.Provider>
    )
}

export function useLanguage() {
    const context = useContext(LanguageContext);
    if (!context) throw new Error("useLanguage must be used within an LanguageProvider");
    const { lang, setLang, optionsLang, translate, orderFromDeposit, setOrderFromDeposit, orderFromRetirada, setOrderFromRetirada, bankSelected, setBankSelected } = context;
    return ({ lang, setLang, optionsLang, translate, orderFromDeposit, setOrderFromDeposit, orderFromRetirada, setOrderFromRetirada, bankSelected, setBankSelected });
}